export default __webpack_public_path__ + "static/carvana-4678a6323dc843e68faa8baea7cb78ac.svg";